// Imports
import React from "react"
import { Main, Wrapper } from "fajny-react"

import BaseLayout from "./BaseLayout"

const PageLayout = ({ title, description, category, keywords, children }) => {
    return (
        <BaseLayout
            title={title}
            description={description}
            category={category}
            keywords={keywords}
        >
            <Wrapper>
                <Main size="large">{children}</Main>
            </Wrapper>
        </BaseLayout>
    )
}

export default PageLayout
